<div class="flex flex-col container">
  <nz-form-label [nzSpan]="10" nzFor="key">{{ to.label }}</nz-form-label>
  <nz-select required [formControl]="formControl" [formlyAttributes]="field" class="min-w-52" nzMode="multiple" nzPlaceHolder="Inserted are removed" [nzSize]="size"[(ngModel)]="listOfSelectedValue">
      <nz-option *ngFor="let option of to.listOfOption" [nzLabel]="option.label" [nzValue]="option.value"></nz-option>
      <nz-option *ngFor="let option of to.listOfSelectedValue" [nzLabel]="option.label" [nzValue]="option.value" nzHide></nz-option>
  </nz-select>
</div>
